import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt, faLock, faShieldAlt, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Form, Alert, InputGroup } from "react-bootstrap";
import { useHistory, useLocation, Link } from "react-router-dom";
import AkasbLogo from "../../assets/img/logo_akasb.png";

const ResetPassword = () => {
    const [passwords, setPasswords] = useState({ newPassword: "", confirmPassword: "" });
    const [erro, setErro] = useState("");
    const [sucesso, setSucesso] = useState("");
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const token = query.get("token");
    const email = query.get("email");

    const API_BASE_URL= process.env.REACT_APP_API_BASE_URL;

    const handleReset = async (e) => {
        e.preventDefault();
        setErro("");

        const API_BASE_URL_AUTH_RESET= `${API_BASE_URL}/auth/reset-password`;

        if (passwords.newPassword !== passwords.confirmPassword) { setErro("As passwords não coincidem."); return; }
        setLoading(true);
        try {
            const response = await fetch(API_BASE_URL_AUTH_RESET, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, email, newPassword: passwords.newPassword })
            });
            if (response.ok) {
                setSucesso("Password alterada com sucesso!");
                setTimeout(() => history.push("/connect/login"), 2500);
            } else {
                const errorText = await response.text();
                setErro(errorText || "Erro ao redefinir a password.");
            }
        } catch { setErro("Erro de ligação ao servidor."); }
        finally { setLoading(false); }
    };

    const inputStyle = { border: "1.5px solid #e9ecef", height: 50, fontSize: 15, background: "#f8f9fa" };
    const prefixStyle = { background: "#f8f9fa", border: "1.5px solid #e9ecef", borderRight: "none" };

    return (
        <main style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <div style={{ width: "100%", maxWidth: 420 }}>
                {/* Logo */}
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                    <img src={AkasbLogo} alt="AKASB" style={{ width: 68, marginBottom: 14 }} />
                    <div style={{ color: "white", fontSize: 22, fontWeight: 900, letterSpacing: 2, fontFamily: "'Anton', sans-serif" }}>AKASB</div>
                </div>

                {/* Card */}
                <div style={{ background: "white", borderRadius: 20, padding: "36px 32px", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
                    <div style={{ width: 56, height: 56, borderRadius: 16, background: "rgba(30,29,69,0.08)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                        <FontAwesomeIcon icon={faShieldAlt} style={{ fontSize: 22, color: "#1e1d45" }} />
                    </div>

                    <h2 style={{ fontWeight: 800, fontSize: 22, color: "#1e1d45", marginBottom: 4 }}>Nova Password</h2>
                    <p style={{ color: "#9ca3af", fontSize: 14, marginBottom: 28 }}>Escolha uma password segura para a sua conta.</p>

                    {erro && <Alert variant="danger" style={{ borderRadius: 12, fontSize: 14 }}>{erro}</Alert>}

                    {sucesso ? (
                        <div style={{ textAlign: "center", padding: "24px 0" }}>
                            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#f0fdf4", border: "2px solid #bbf7d0", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                                <span style={{ fontSize: 28 }}>✓</span>
                            </div>
                            <div style={{ fontWeight: 700, color: "#166534", fontSize: 16 }}>{sucesso}</div>
                            <div style={{ color: "#9ca3af", fontSize: 13, marginTop: 6 }}>A redirecionar para o login...</div>
                        </div>
                    ) : (
                        <Form onSubmit={handleReset}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Nova Password</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faUnlockAlt} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                    <Form.Control required type="password" placeholder="Mínimo 6 caracteres" value={passwords.newPassword}
                                        onChange={e => setPasswords({ ...passwords, newPassword: e.target.value })}
                                        style={{ ...inputStyle, borderLeft: "none" }} />
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Confirmar Password</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faLock} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                    <Form.Control required type="password" placeholder="Repita a password" value={passwords.confirmPassword}
                                        onChange={e => setPasswords({ ...passwords, confirmPassword: e.target.value })}
                                        style={{ ...inputStyle, borderLeft: "none" }} />
                                </InputGroup>
                            </Form.Group>

                            <button type="submit" disabled={loading} style={{ width: "100%", height: 50, background: loading ? "#6b7280" : "#1e1d45", border: "none", borderRadius: 12, color: "white", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer" }}>
                                {loading ? "A guardar..." : "Confirmar Alteração"}
                            </button>
                        </Form>
                    )}
                </div>

                <div style={{ textAlign: "center", marginTop: 24 }}>
                    <Link to="/connect/login" style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <FontAwesomeIcon icon={faAngleLeft} /> Voltar ao Login
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default ResetPassword;
